export enum OpportunityType {
  EXISTING_BUSINESS = "existing_business",
  NEW_BUSINESS = "new_business",
}
